import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type KpiSub } from 'types/models';

export interface KPISubsState extends EntityState<Partial<KpiSub>>, ActiveState {}

const store = createEntityStore<KPISubsState>({ isLoadingProgress: false }, { resettable: true, name: 'kpiSubs' });

export default store;
